import { Button, Col, Section, SectionHeading } from "@/components";
import { SectionLink } from "@anoki/fse-common";
import clsx from "clsx";
import { ComponentType, PropsWithChildren, ReactNode } from "react";
import { RichText } from "../RichText";
import "./WhatDoYouNeed.scss";

type WhatDoYouNeedProps = PropsWithChildren<{
  title: ReactNode;
  description?: ReactNode;
  links: EnhancedSectionLink[];
  asLink?: "a" | ComponentType<any>;
  showBlueBackground?: boolean;
}>;

type EnhancedSectionLink = SectionLink & {
  isNewTab?: boolean;
};

export const WhatDoYouNeed = ({
  title,
  description,
  links,
  asLink = "a",
  showBlueBackground = false,
}: WhatDoYouNeedProps) => {
  return (
    <Section
      className={`base-col ui-what-do-you-need-section ${showBlueBackground ? "blue-background" : ""}`}
    >
      <Col className="ui-what-do-you-need-content">
        <SectionHeading
          title={title}
          fs="2"
          mdFs="1"
          color="slate-20"
          titleMarginBottom="0"
          descriptionMarginBottom="0"
          description={description ? <RichText description={description}></RichText> : undefined}
        />
      </Col>
      <ul
        role="list"
        aria-label={`Lista di ${title}`}
        className={clsx(
          "list-style-none ui-what-do-you-need-links",
          links.length < 4 ? "row" : "grid",
        )}
      >
        {links?.map(({ link, title, isNewTab }, index) => (
          <li key={link}>
            <Button
              asLink={asLink}
              href={link}
              size="2"
              variant={index > 0 ? "secondary" : "primary"}
              // textColor={index > 0 ? "primary" : undefined}
              // bg={index > 0 ? "white" : undefined}
              // className={index > 0 ? "br-color-primary" : undefined}
              target={isNewTab ? "_blank" : undefined}
              rel={isNewTab ? "noopener noreferrer" : undefined}
            >
              {title}
            </Button>
          </li>
        ))}
      </ul>
    </Section>
  );
};
